<template>
  <div>
    微信测侧
    <!-- <signature /> -->
    <!-- <signature111/> -->
  </div>
</template>

<script>
// import signature from "./signature";
// import signature111 from "./signature111.vue"
export default {
  components: {
    // signature,
    // signature111
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/wxTest.vue